import { useSentry } from '@myfunnow/web-core/sentry'

import { MemberAuthType } from '@/view-models/account'

export function useSentryRegister() {
  const nuxtApp = useNuxtApp()
  const user = computed(() => nuxtApp.$auth.user)

  const username = computed(() => {
    if (user.value?.name) {
      return user.value.name
    }

    if (user.value?.nickname) {
      return user.value.nickname
    }

    switch (user.value?.auth_type) {
      case MemberAuthType.MemberAuthTypeFB:
      case MemberAuthType.MemberAuthTypeGoogle:
      case MemberAuthType.MemberAuthTypeEmail:
      default:
        return user.value?.email?.split('@')[0] ?? ''
    }
  })

  const sentry = useSentry()

  function setSentryUserData(userData: any | null) {
    const data = userData
      ? {
          ...(!!userData?.uid && { id: userData.uid }),
          ...(!!userData?.email && { email: userData.email }),
          ...(!!username.value && { username: username.value }),
        }
      : null

    sentry?.setUser(data)
  }

  watch(user, setSentryUserData, { immediate: true })
}
